define('plugin/invoice/view/InvoiceRecurringProfileListItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice recurring profile item view
     *
     * @class InvoiceRecurringProfileListItemView
     */
    return LayoutView.extend({

        template: '#invoice_recurring_profile_list_item_view'

    });

});
